export default __webpack_public_path__ + "static/media/product-banner2.10578996.png";